// extracted by mini-css-extract-plugin
export var filterPanel = "styles-module__filterPanel___yIGhC";